import { useFormikContext, useField } from 'formik'
import { useCallback, useMemo, useEffect } from 'react'
import { SalesTeam } from '@user/store/salesTeam'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { ILeadFormModel } from '../../../typings'

type Props = {
  name: string
  optionList: SalesTeam[]
  required?: boolean
}

export function useData(props: Props) {
  const { name, optionList, required } = props
  const tidalThemeActive = useTidalThemeActive()

  const options = optionList

  const {
    setFieldValue,
    isSubmitting,
    values: { salesTeamId },
  } = useFormikContext<ILeadFormModel>()

  const [{}, { error, touched }] = useField<string[]>({
    name,
    validate: (value) => {
      if (required !== undefined ? required : true && !value) {
        return 'Required'
      }
    },
  })

  const showError =
    required !== undefined
      ? Boolean(required && error && touched)
      : Boolean(error && touched)
  const helperText = showError ? error : ''

  const getLabel = useCallback(
    (option: SalesTeam) => `${option?.name} - ${option?.branchName}`,
    [],
  )

  const getId = useCallback((option: SalesTeam) => {
    return String(option.id)
  }, [])

  useEffect(() => {
    if (!salesTeamId && options?.length == 1) {
      setFieldValue(name, options[0].id)
    }
  }, [salesTeamId, setFieldValue])

  const initialOption = useMemo(() => {
    if (salesTeamId) {
      const value = options.find((x) => x.id === parseInt(salesTeamId))
      if (value) return value
    }
    return null
  }, [options, salesTeamId])

  useEffect(() => {
    if (salesTeamId == '' && initialOption) {
      setFieldValue('salesTeamId', initialOption.id)
    }
  }, [salesTeamId, initialOption, setFieldValue])

  const height = tidalThemeActive ? '65px' : '54px'

  return {
    getLabel,
    getId,
    items: options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
    height,
  }
}
